import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { useTranslation } from '../hooks/useTranslation';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();
  const { t } = useTranslation();

  return (
    <div 
      className="landing-page"
      style={{
        backgroundImage: 'url(/images/background.jpg)',
      }}
    >
      <div className="landing-hero">
        <h1 className="landing-title">{t('landing.title')}</h1>
        <p className="landing-subtitle">
          {t('landing.subtitle')}
        </p>
        <p className="landing-description">
          {t('landing.description')}
        </p>
        <div className="landing-actions">
          <Link to="/products" className="landing-btn landing-btn-primary">
            {t('landing.orderNow')}
          </Link>
          {!isSignedIn && (
            <button 
              onClick={() => navigate('/sign-in')} 
              className="landing-btn landing-btn-secondary"
            >
              {t('landing.signIn')}
            </button>
          )}
          {isSignedIn && (
            <Link to="/profile" className="landing-btn landing-btn-secondary">
              {t('landing.myProfile')}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
